import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { Company, CompanyRepresentative } from '../shared/models/company';
import { ApiUrlProvider } from './api-url.provider';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<Company[]>>{
    return this.http.get<IApiResult<Company[]>>(`${this.apiUrlProvider.url}/Company`);
  }

  add(entity: Company): Observable<IApiResult<Company>>{
    return this.http.post<IApiResult<Company>>(`${this.apiUrlProvider.url}/Company`, entity);
  }

  update(entity: Company): Observable<IApiResult<Company>>{
    return this.http.post<IApiResult<Company>>(`${this.apiUrlProvider.url}/Company/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/Company/${entityId}/delete`, null);
  }

  getCompanyRepresentatives(companyId?: number): Observable<IApiResult<CompanyRepresentative[]>>{
    let url = companyId ? `${this.apiUrlProvider.url}/CompanyRepresentative/${companyId}`
      : `${this.apiUrlProvider.url}/CompanyRepresentative`;
      
    return this.http.get<IApiResult<CompanyRepresentative[]>>(url);
  }

  addCompanyRepresentative(companyId: number, entity: CompanyRepresentative): Observable<IApiResult<CompanyRepresentative>>{
    return this.http.post<IApiResult<CompanyRepresentative>>(`${this.apiUrlProvider.url}/CompanyRepresentative/${companyId}`, entity);
  }

  updateCompanyRepresentative(companyId: number, entity: CompanyRepresentative): Observable<IApiResult<CompanyRepresentative>>{
    return this.http.post<IApiResult<CompanyRepresentative>>(`${this.apiUrlProvider.url}/CompanyRepresentative/${companyId}/${entity.id}`, entity);
  }

  deleteCompanyRepresentative(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/CompanyRepresentative/${entityId}/delete`, null);
  }

}
